import { render, staticRenderFns } from "./TasklistRoot.vue?vue&type=template&id=53ba71ae&scoped=true&"
import script from "./TasklistRoot.vue?vue&type=script&lang=js&"
export * from "./TasklistRoot.vue?vue&type=script&lang=js&"
import style0 from "./TasklistRoot.vue?vue&type=style&index=0&id=53ba71ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ba71ae",
  null
  
)

export default component.exports